module.exports = __webpack_public_path__ + "img/tm.ada7eeb6.svg";